import { Suspense } from 'react'
import { Toaster } from 'sonner'
import { ReduxProvider } from './providers/ReduxProvider'
import { AppRouter } from '@/features/routes/AppRouter'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { GoogleDriveInitializer } from '@/features/google-drive/components/GoogleDriveInitializer'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
  || '541716939925-ftsktgf5culju42gl1qt96qvh39tf2p4.apps.googleusercontent.com'

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ReduxProvider>
        <GoogleDriveInitializer />
        <Suspense fallback={<LoadingSpinner />}>
          <AppRouter />
        </Suspense>
        <Toaster position="top-right" richColors />
      </ReduxProvider>
    </GoogleOAuthProvider>
  )
}

export default App
